export const AProlongationOptions = [
    // { value: "0", label: "bez prodloužení" },
    // { value: "60", label: "1 minuta" },
    // { value: "120", label: "2 minuty" },
    { value: "300", label: "5 minut" },
    { value: "600", label: "10 minut" },
    { value: "1800", label: "30 minut" },
    { value: "3600", label: "1 hodina" }
];
export const getProlongationLabel = (value) => {
    let res = AProlongationOptions.filter(obj => obj.value == value)[0];
    return res ? res.label : 'N/A';
};
